import SingleOptimizationTable from './table'

export default SingleOptimizationTable
